import type { PrivateBankingProductCatalogueResponse, ServiceAgreementV2 } from '../../eBankingTempTypes';

type ConflictingAgreement = Pick<ServiceAgreementV2, 'serviceDefinitionId' | 'isAlive'>;

const productsOnBusinessRelation = (serviceAgreements: ConflictingAgreement[] | undefined): Set<string> =>
  new Set(
    (serviceAgreements ?? [])
      .filter(({ isAlive }) => isAlive)
      .flatMap(({ serviceDefinitionId }) => serviceDefinitionId ?? []),
  );

export const getProductConflictMessages = (
  selectedProducts: PrivateBankingProductCatalogueResponse[],
  serviceAgreements: ConflictingAgreement[] | undefined,
): string[] => {
  const blockingProductIds = new Set([
    ...productsOnBusinessRelation(serviceAgreements),
    ...selectedProducts.flatMap(({ productId }) => productId ?? []),
  ]);

  const messages = selectedProducts
    .flatMap((product) => product.conflictsWith ?? [])
    .filter(
      ({ conflictingProductIds }) =>
        conflictingProductIds?.length && conflictingProductIds.every((id) => blockingProductIds.has(id)),
    )
    .flatMap(({ message }) => message ?? []);

  return [...new Set(messages)];
};
